module.exports = __webpack_public_path__ + "img/announcement.069bc860.svg";